import ManageAccounts from 'features/myVaro/screens/ManageAccounts/ManageAccounts';
import React from 'react';

export default function ManageAccountsPage() {
  return <ManageAccounts />;
}
